// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FUJh","controls":"styles_controls__1cbeB","charLimit":"styles_charLimit__1yYu4","input":"styles_input__NY6Lf","send":"styles_send__3B91u"};